import { motion } from 'motion/react';
import { Card } from './ui/card';
import { TrendingUp, TrendingDown, ArrowRight } from 'lucide-react';

interface ComparisonCardProps {
  current: number;
  yesterday: number;
  label: string;
  unit: string;
}

export function ComparisonCard({ current, yesterday, label, unit }: ComparisonCardProps) {
  const difference = current - yesterday;
  const percentChange = yesterday !== 0 ? (difference / yesterday) * 100 : 0;
  const isIncrease = difference > 0;
  const isStable = Math.abs(difference) < 0.1;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      whileHover={{ scale: 1.02 }}
    >
      <Card className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <p className="text-xs text-gray-500 mb-1">{label}</p>
            <p className="text-xl">{current.toFixed(2)} {unit}</p>
          </div>

          <div className="flex items-center gap-2">
            {isStable ? (
              <ArrowRight className="w-5 h-5 text-gray-400" />
            ) : isIncrease ? (
              <TrendingUp className="w-5 h-5 text-red-500" />
            ) : (
              <TrendingDown className="w-5 h-5 text-blue-500" />
            )}
            
            <div className="text-right">
              <p className={`text-sm ${
                isStable ? 'text-gray-500' : isIncrease ? 'text-red-600' : 'text-blue-600'
              }`}>
                {isIncrease ? '+' : ''}{difference.toFixed(2)}
              </p>
              <p className="text-xs text-gray-400">
                vs wczoraj
              </p>
            </div>
          </div>
        </div>
      </Card>
    </motion.div>
  );
}
